'use client'
import { LoginByEmailCard } from '@/features/auth/login-by-email'

export default function Page() {
  return <LoginByEmailCard />
}
